import memoize from "memoize-one";
import deepEqual from "lodash/isEqual";

// return a list of items by status
export default memoize((items, propName, propValue) => {
  return items.filter(item => item[propName] === propValue);
}, deepEqual);
